import { Tabs, TabsProps } from "antd";
import { useEffect, useState } from "react";
import { APWorkflowStatusTab } from "../../constants/ap-workflow";
import { DEFAULT_PAGINATION } from "../../constants/pagination";
import { usePageStore } from "../../context/PageStoreContext";
import { ISuppliersByNameResponse } from "../../interfaces/supplier";
import { MasterDataServices } from "../../services/master-data";
import { SupplierServices } from "../../services/supplier";
import TabDetail from "./components/tab-detail";

const DEFAULT_TAB_ACTIVE = "review";

async function fetchSuppliers(): Promise<any[]> {
  const res: ISuppliersByNameResponse = await SupplierServices.getSuppliersByName({
    params: { page: 1, pageSize: 5000 },
  });
  return res?.data?.results || [];
}

async function fetchApOwners(): Promise<any[]> {
  const res = await SupplierServices.getListUserBaseRole();
  return res?.data.apOwner || [];
}

const FlightWorkflowPage = () => {
  const { setPageValue, getPageValue } = usePageStore();
  const savedTab = getPageValue()?.currentStatus || DEFAULT_TAB_ACTIVE;
  const [activeTab, setActiveTab] = useState(savedTab);
  const [suppliers, setSuppliers] = useState<any[]>([]);
  const [apOwners, setApOwners] = useState<any[]>([]);
  const [masterData, setMasterData] = useState<any>();

  const fetchMasterData = async () => {
    try {
      const types = [
        "PAYMENT_TERM_RULE_NOMINAL_ACCOUNT_DEBIT",
        "PAYMENT_TERM_RULE_NOMINAL_ACCOUNT_CREDIT",
        "PAYMENT_TERM_RULE_UNDERS_OVERS_AUTO_MATCH",
      ];

      const masterPromises = types.map((type) => MasterDataServices.getAllByType(type).then((res) => res?.data || []));

      const [accountDebits, accountCredits, autosMatch] = await Promise.all([...masterPromises]);

      return {
        accountDebits,
        accountCredits,
        autosMatch,
      };
    } catch (error) {
      console.error("Error fetching master data:", error);
    } finally {
    }
  };

  useEffect(() => {
    const loadSuppliers = async () => {
      try {
        const [suppliers, apOwners, masterData] = await Promise.all([
          fetchSuppliers(),
          fetchApOwners(),
          fetchMasterData(),
        ]);
        setSuppliers(suppliers);
        setApOwners(apOwners);
        setMasterData(masterData);
      } catch (err) {
        console.error("Error fetching suppliers:", err);
      }
    };
    setTimeout(() => {
      loadSuppliers();
    }, 2500);
  }, []);

  const items: TabsProps["items"] = [
    {
      key: `${APWorkflowStatusTab.REVIEW}`,
      label: "Review",
    },
    {
      key: `${APWorkflowStatusTab.MATCHED}`,
      label: "Matched",
    },
    {
      key: `${APWorkflowStatusTab.READY_TO_EXPORT}`,
      label: "Ready to Export",
    },
    {
      key: `${APWorkflowStatusTab.EXPORTED}`,
      label: "Exported",
    },
    {
      key: `${APWorkflowStatusTab.COMPLETED}`,
      label: "Completed",
    },
  ];

  return (
    <div>
      <h2 className="title-page">Flight Workflow</h2>
      <Tabs
        activeKey={activeTab}
        onChange={(key) => {
          setActiveTab(key);
          setPageValue({
            pagination: { current: 1, pageSize: DEFAULT_PAGINATION.pageSize, total: 0 },
            currentStatus: key,
          });
        }}
        items={items}
      />
      <TabDetail type="Flight" status={activeTab} suppliers={suppliers} apOwners={apOwners} />
    </div>
  );
};

export default FlightWorkflowPage;
